import '../../../src/global.css'
import React, { useEffect, useState } from 'react'
import cookie from 'react-cookies'
import jwt_decode from 'jwt-decode'
import { Box, Button, Typography } from '@material-ui/core'
import { CMS_TR_PLUS_COOKIE } from '@Hooks/useAuth'
import { THAIRATH_AUTH_LAUNCH_URL } from '../Login'

const errorMessages: Record<string, string> = {
  not_configured: 'Thairath Auth is not configured.',
  auth_failed: 'Sign in with Thairath Auth failed.',
  invalid_state: 'The sign in request expired. Please try again.',
  no_email: 'Thairath Auth did not return an email for this account.',
  user_not_active:
    'บัญชีของคุณยังไม่ได้เปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบเพื่อขอสิทธิ์การใช้งาน',
}

/* callback landing page: the api puts the session token (or an error) in the url fragment */
export default function ThairathAuthComplete() {
  const [error, setError] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
    const token = params.get('token')
    const errorCode = params.get('error')

    if (token) {
      try {
        jwt_decode(token)
        cookie.save(CMS_TR_PLUS_COOKIE, token, {
          path: '/',
          maxAge: 60 * 60 * 24,
        })
        window.location.replace('/')
        return
      } catch (e) {
        setError(errorMessages.auth_failed)
        return
      }
    }
    setError(errorMessages[errorCode || ''] || errorMessages.auth_failed)
  }, [])

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      {error && (
        <>
          <Typography style={{ color: 'red' }}>{error}</Typography>
          <Box mt={2}>
            <Button
              variant="contained"
              color="primary"
              href={THAIRATH_AUTH_LAUNCH_URL}
            >
              Sign in
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}
